module.exports = __webpack_public_path__ + "img/cover.a0cc033d.png";